const PREFIX = 'SELECT_VIDEO_FORM/';

export const LIST_VIDEO = `${PREFIX}LIST`;

export const SET_VIDEO = `${PREFIX}SET_VIDEO`;

export const SET_ORDER = `${PREFIX}SET_ORDER`;

export const SET_SORT = `${PREFIX}SET_SORT`;

export const SET_COUNT = `${PREFIX}SET_COUNT`;

export const SET_SKIP = `${PREFIX}SET_SKIP`;
